export enum ConversationRecipientType {
    /**
     * The recipient type for a conversation is an agent
     */
    AGENT = 'AGENT',
    /**
     * The recipient type for a conversation is a team
     */
    TEAM = 'TEAM'
}